import { api } from "../../utils/api";

export async function getCommissions(data) {
  try {
    const response = await api.get('commission', { params: data });
    return response.data;
  } catch (error) {
    throw error;
  }
}
//ver data n esta sendo certo